import {env} from './env.config';

let wechat = {
    sdk: '//res.wx.qq.com/open/js/jweixin-1.2.0.js'
    //sdk: '//res.wx.qq.com/open/js/jweixin-1.3.2.js'
};

let baidu = {
    // ak: '6BTx5FW3fg1dXsZkDtwfCQlKjtWp0HSA',
    ak: '5l9JoEWAdfqYCcMP7worbEWMRCHOwQfU',
    geoconvV1: '//api.map.baidu.com/geoconv/v1/',       // 转换坐标
    geocoderV2: '//api.map.baidu.com/geocoder/v2/'      // 坐标转出地址
};
// baidu.sdk = "//api.map.baidu.com/api?v=3.0&s=1&ak="+ baidu.ak;
baidu.sdk = "//api.map.baidu.com/api?v=4.0&ak="+ baidu.ak;
// baidu.sdk = "//api.map.baidu.com/api?type=webgl&v=3.0&ak="+ baidu.ak;

let config = {
    local: {
        wechat,
        baidu,
        stardust: {
            url: '//test.xt.xxx.com/',
            flowRouter: 'webapi/flowRouter'
        }
    },
    test: {
        wechat,
        baidu,
        stardust: {
            url: '//test.xt.xxx.com/',
            flowRouter: 'webapi/flowRouter'
        }
    },
    online: {
        wechat,
        baidu,
        stardust: {
            url: '//xt.xxx.com/',
            flowRouter: 'webapi/flowRouter'
        }
    }
};

export default config[env];



// WEBPACK FOOTER //
// ./src/common/js/thirdApiConfig.js